<template>
  <div
    v-if="page"
    :class="isSocailConnect ? '' : { 'inactive-page': !page.isAdmin || page.isInstalled }"
    style="cursor: pointer;"
  >
    <v-avatar :size="60" color="grey lighten-4" style="border: 1px solid #eee">
      <template v-if="page.channel == 'line'">
        <img class="circle" :src="page.pagelogo || '/static/img/assets/livechat/profile.png'" alt />
      </template>
      <template v-else-if="page.channel == 'fb'">
        <img
          class="circle"
          :src="
            'https://graph.facebook.com/' + page.id + '/picture?width=100&height=100&SameSite=None'
          "
          alt
        />
      </template>
    </v-avatar>
    <div class="page-detail">
      <slot name="page-status"></slot>
      <p class="page-name text-truncate">{{ page.name }}</p>
      <span class="page-role">
        <template v-if="!page.isAdmin">{{ $t('No permission') }}</template>
        <template v-else-if="page.isInstalled">{{ $t('Installed') }}</template>
        <template v-else>{{ role }}</template>
      </span>

      <slot name="install-button"></slot>
    </div>
    <slot name="select-page"></slot>
  </div>
</template>

<script>
export default {
  props: ['value', 'isSocailConnect'],
  computed: {
    page: function() {
      let vm = this
      let page = this.value || {}
      page.isAdmin = true

      return page
    }
  },
  data: function() {
    return {
      role: ''
    }
  },
  methods: {
    onPageClick: function() {
      if (this.page.isAdmin || !this.page.isInstalled) {
        this.$emit('onPageClick', this.page)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inactive-page {
  opacity: 0.4 !important;
  background: #eee !important;
  cursor: not-allowed !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/allbots/PageItem.vue